import React, { useEffect, useState } from "react";
import moment from "moment";
import Hashtags from "react-highlight-hashtags";
import LazyLoad from "react-lazy-load";
import { useSelector } from "react-redux";
import {
  ArrowDownIcon,
  FacebookIcon,
  FavoriteIcon,
  InstagramIcon,
  LinkIcon,
  PlusIcon,
  TwitterIcon,
  VideoPlayIcon,
  YoutubePlayIcon,
  TagClose,
  PinterestIcon,
  TwitterWBIcon,
} from "../../../Icons/icons.component";
import ArticleTags from "../ArticleTags";
import { FEED_DETAILS } from "../../../../constants/route-constants";
import { TagsListModal } from "../../TagsAndFavourites/Tags/TagsListModal";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import { httpDelete } from "../../../../utility/requestHelper";
import VideoThumbnail from "../../../../assets/images/video-thumb-small.svg";

import {
  DATE_FORMATS,
  SOCIAL_SOURCES,
} from "../../../../constants/app-constant";
import SocialReactionsTray from "./SocialReactionsTray";
import {
  formatDate,
  getUniqueValuesFromList,
  truncate,
} from "../../../../utility/common-methods";
const { FACEBOOK, INSTAGRAM, YOUTUBE, TWITTER, PINTEREST, LINKEDIN } =
  SOCIAL_SOURCES;

export default function SingleSocialFeedItem({
  feed,
  selectedFeeds,
  onFeedSelect,
  allArticleList,
  entityName,
  forEmbedArticles,
  updatedBulkSentiment,
  updatedBulkFavourite,
  clientId,
  entityId,
  onSingleFeedSelect,
  updateSelectedTagsToFeeds,
  isyoutube=false
}) {
  const updatedSentiment = updatedBulkSentiment;
  const updatedFavourite = updatedBulkFavourite;
  const [showLikesTooltip, setShowLikesTooltip] = useState(false);
  const {
    message,
    created_at,
    comment_count,
    channel_type,
    share_count,
    name,
    like_count,
    page_details,
    id,
    tags,
    permalink,
    thumbnail_link,
    title,
    view_count,
    from_username,
    attachments,
    dislike_count,
    reaction_metadata,
    reaction_count,
    media_link,
    media_type,
  } = feed || {};
  const [showAddTagListModal, setShowAddTagListModal] = useState(false);
  const [tagsList, setTagsList] = useState([]);
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  useEffect(() => {
    setTagsList(tags);
  }, [tags]);

  const { display_picture } = page_details || {};

  const handleFeedClick = () => {
    localStorage.setItem("articleIdList", JSON.stringify(allArticleList));
    window.open(
      `https://${window.location.host}${FEED_DETAILS}/sad/${selectedClient.id}-${channel_type}/${id}?entityName="${entityName}"`,
      "_blank"
    );
  };

  const getAddedTag = (tags) => {
    setTagsList(getUniqueValuesFromList([...tagsList, ...tags], "tag_id"));
  };

  const renderTags = () => {
    if (tagsList && tagsList.length) {
      return tagsList.map((tag) => {
        const tagName = tag.tag_name || tag.name;
        return (
          <>
            <span className="tagName">
              {tagName}
              <span
                onClick={() => removeTagFromList(tag.tag_id)}
                className="tagClose"
              >
                <TagClose />
              </span>
            </span>
          </>
        );
      });
    }
    return null;
  };

  const removeTag = (tagObject) => {
    httpDelete(
      `${unifiedEnvConfig.DELETE_TAG_FROM_FEED.replace("{id}", id)}?client_id=${
        selectedClient.id
      }`,
      tagObject
    ).catch((err) => {
      console.log(err);
      alert("Couldn't delete the tag.");
    });
  };

  const removeTagFromList = (tagId) => {
    let tagForMainList = [];
    const tagObject =
      tagsList && tagsList.length
        ? tagsList
            .filter((i) => i.tag_id == tagId)
            .map((item) => {
              tagForMainList.push(item);
              return {
                tag_id: item.tag_id,
                social_feed_id: id,
                channel_type: channel_type,
              };
            })
        : [];
    setTagsList(tagsList.filter((i) => i.tag_id != tagId));
    updateSelectedTagsToFeeds(tagForMainList, true, entityId, id);
    removeTag(tagObject[0]);
  };

  const gotoPermalink = () => {
    if (!permalink) return;
    window.open(permalink, "_blank");
  };
  const isSingleFeedSelected = () => {
    const tempArr =
      selectedFeeds &&
      selectedFeeds.filter((f) => f.id == feed.id && f.entityId == entityId);
    return tempArr && tempArr.length;
  };

  const pageTitle =
    channel_type === YOUTUBE
      ? name
      : channel_type === TWITTER
      ? `@${from_username}`
      : channel_type === LINKEDIN
      ? from_username
      : channel_type === PINTEREST
      ? from_username
      : page_details && page_details.name;

  const showMediaAttachments = () => {
    return Array.isArray(attachments) && attachments.length
      ? attachments.map((src, index) => {
          if (!src) {
            return null;
          }
          const { media_link, media_type } = src;
          if (media_type === "image") {
            return (
              <div className="imgThumbWrap">
                <div className="imgThumb">
                  <img
                    alt={""}
                    key={src}
                    src={media_link}
                    onClick={handleFeedClick}
                  />
                </div>
              </div>
            );
          }
          if (media_type === "video") {
            return (
              <div className="videoThumb">
                <VideoPlayIcon />
                <a href={permalink} target="_blank">
                  <img
                    src={media_link}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = VideoThumbnail;
                    }}
                  />
                </a>
              </div>
            );
          }
          return null;
        })
      : "";
  };

  const selectedFeedWithTopic = { ...feed, topic_name: entityName };
  return (
    <div className="innerFeedItem socialFeedItem">
      {showAddTagListModal ? (
        <TagsListModal
          show={showAddTagListModal}
          onCancel={() => setShowAddTagListModal(false)}
          feedDetail={feed}
          addedTag={getAddedTag}
        />
      ) : null}
      <div className="headlineWrapper">
        <label className="inputWrap">
          <input
            type="checkbox"
            class="styled-checkbox"
            onChange={(e) =>
              onSingleFeedSelect &&
              onSingleFeedSelect(!isSingleFeedSelected(), selectedFeedWithTopic)
            }
            checked={isSingleFeedSelected()}
          />
          <span className="checkmark"></span>
        </label>
        <div className="feedInfoHeader">
          <div className="feedNamePic">
            {display_picture && (
              <img src={display_picture} className="feedPic" />
            )}

            {from_username ? (
              <span className="feedName nonClickable">{from_username}</span>
            ) : (
              <span className="feedName nonClickable">{pageTitle}</span>
            )}
          </div>
          {(pageTitle || display_picture || from_username) && channel_type && (
            <span className="feedDivider"></span>
          )}
          <div className="feedChannelDate">
            {channel_type == INSTAGRAM && <InstagramIcon />}
            {channel_type == FACEBOOK && <FacebookIcon />}
            {channel_type == YOUTUBE && <YoutubePlayIcon />}
            {channel_type == TWITTER && <TwitterWBIcon />}
            {channel_type == LINKEDIN && (
              <img
                src="https://backendportal.conceptbiu.com/assets/article_download/icons8-linkedin-30.png"
                alt="NA"
                width={25}
                height={25}
              />
            )}
            {/* {channel_type == PINTEREST && <PinterestIcon />} */}
            <span className="newsDate"></span>
          </div>
        </div>
        <div className="rightContainer">
          <ul className="dropDownContainer">
            <li className="themeLi tlLink">
              <span onClick={gotoPermalink} className="linkIcon clickable">
                <div className="hasTooltip">
                  <LinkIcon />
                  <span className="tooltipWrap left">Go to Page</span>
                </div>
              </span>
            </li>
            {!forEmbedArticles && (
              <ArticleTags
                article={feed}
                hideTheme
                callSocialAPI
                showFavouriteTag
                updatedBulkSentiment={updatedSentiment}
                updatedBulkFavourite={updatedFavourite}
                isSingleFeedSelected={isSingleFeedSelected()}
                isSocial
                entityName={entityName}
                showTicket={true}
              />
            )}
          </ul>
        </div>
      </div>
      <div className="feedDetails" onClick={handleFeedClick}>
        {channel_type == YOUTUBE ? (
          <Hashtags text={title || ""} />
        ) : (
          <Hashtags text={truncate(message)} />
        )}
      </div>

      <div className="imgContainer videoContainer">
        {isyoutube === false?
          <LazyLoad offsetVertical="1000">
            <>
              {thumbnail_link && channel_type == YOUTUBE ? (
                <div className="videoThumb">
                  <a href={permalink} target="_blank">
                    <VideoPlayIcon />
                    <img src={thumbnail_link} alt="NA" />
                  </a>
                </div>
              ) : (
                thumbnail_link && (
                  <div className="imgThumbWrap">
                    <div className="imgThumb">
                      <img
                        src={thumbnail_link}
                        alt="NA"
                        onClick={handleFeedClick}
                      />
                    </div>
                  </div>
                )
              )}
            </>
          </LazyLoad>
        :""}

        {media_link && media_type == "image" && channel_type != LINKEDIN && (
          <div className="imgThumbWrap">
            <div className="imgThumb">
              <img alt={""} src={media_link} onClick={handleFeedClick} />
            </div>
          </div>
        )}
        {media_link && media_type == "video" && (
          <div className="videoThumb">
            <VideoPlayIcon />
            <a href={permalink} target="_blank">
              <img
                src={media_link}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = VideoThumbnail;
                }}
              />
            </a>
          </div>
        )}
        {showMediaAttachments()}
      </div>
      <div className="metaTagsWrap">
        {channel_type != PINTEREST && (
          <div
            className="mtWrap"
            onMouseEnter={() => {
              setShowLikesTooltip(true);
            }}
            onMouseLeave={() => {
              setShowLikesTooltip(false);
            }}
          >
            <span className="label-span hoverable">Likes : </span>
            <span>
              <span
                className={
                  channel_type == FACEBOOK
                    ? "likeCount fblikeCount"
                    : "likeCount"
                }
              >
                {channel_type == FACEBOOK ? reaction_count : like_count}
              </span>
              {showLikesTooltip && channel_type == FACEBOOK && (
                <SocialReactionsTray reaction_metadata={reaction_metadata} />
              )}
            </span>
          </div>
        )}
        {channel_type == YOUTUBE && (
          <div className="mtWrap">
            <span className="label-span">Dislikes :</span>{" "}
            <span>{dislike_count}</span>
          </div>
        )}
        {channel_type == TWITTER && (
          <div className="mtWrap">
            <span className="label-span">Retweets :</span>{" "}
            <span>{share_count}</span>
          </div>
        )}
        <div className="mtWrap">
          <span className="label-span">Comments :</span>{" "}
          <span>{comment_count}</span>
        </div>
        {channel_type == FACEBOOK && (
          <div className="mtWrap">
            <span className="label-span">Share :</span>{" "}
            <span>{share_count}</span>
          </div>
        )}

        {channel_type == LINKEDIN && (
          <div className="mtWrap">
            <span className="label-span">Share :</span>{" "}
            <span>{share_count}</span>
          </div>
        )}

        {channel_type == YOUTUBE && (
          <div className="mtWrap">
            <span className="label-span">Views :</span>{" "}
            <span>{view_count}</span>
          </div>
        )}

        <div className="mtWrap">
          <span className="label-span">Publish Date :</span>{" "}
          <span>
            {formatDate(new Date(created_at), DATE_FORMATS.DDMMYYYY_dash)}
          </span>
        </div>

        {!forEmbedArticles && (
          <div className="mtWrap mtAddTag">
            <span
              onClick={() => setShowAddTagListModal(true)}
              href="#"
              className="addTag"
            >
              Add Tag <PlusIcon />{" "}
            </span>
            <div className="tagList">{renderTags()}</div>
          </div>
        )}
      </div>
    </div>
  );
}
